'use strict';

var index = require('../../../../../index-B_8xeRkv.js');

"use strict";
const pluginVersion = "12.4.2";
const defaultGaugePanelEffects = {
  barGlow: false,
  centerGlow: false,
  gradient: true
};
const defaultOptions = {
  barShape: "flat",
  barWidthFactor: 0.5,
  effects: {},
  endpointMarker: "point",
  minVizHeight: 75,
  minVizWidth: 75,
  segmentCount: 1,
  segmentSpacing: 0.3,
  shape: "gauge",
  showThresholdLabels: false,
  showThresholdMarkers: true,
  sizing: index.BarGaugeSizing.Auto,
  sparkline: true,
  textMode: "auto"
};

exports.defaultGaugePanelEffects = defaultGaugePanelEffects;
exports.defaultOptions = defaultOptions;
exports.pluginVersion = pluginVersion;
